import React from "react";
import Modal from "react-modal";
import { FaTimes } from "react-icons/fa";

const OrderSummary = ({
  isOpen,
  onClose,
  totalCartAmount,
  totalAfterDelivery,
  totalAfterDiscount,
  items,
}) => {
  const deliveryCharges = 100;

  const customStyles = {
    content: {
      top: "50%",
      left: "50%",
      right: "auto",
      bottom: "auto",
      marginRight: "-50%",
      transform: "translate(-50%, -50%)",
      width: "80%",
      maxHeight: "80vh",
      overflow: "auto",
      padding: "20px",
      borderRadius: "10px",
    },
    overlay: {
      backgroundColor: "rgba(0, 0, 0, 0.75)",
      zIndex: 1000,
    },
  };

  return (
    <Modal
      isOpen={isOpen}
      onRequestClose={onClose}
      contentLabel="Order Details"
      style={customStyles}
    >
      <div className="container font-twentieth-century md:px-4">
        <div className="flex justify-between mb-4">
          <p className="text-2xl font-semibold">Your Order Summary</p>
          <button
            onClick={onClose}
            className="text-gray-500 hover:text-gray-700 focus:outline-none"
          >
            <FaTimes size={24} />
          </button>
        </div>
        <div className="flex justify-between mb-4">
          <p className="text-xl text-gray-700 font-semibold">Shopping Cart:</p>
          <p className="text-lg text-gray-700 font-medium">
            {items?.length} Item
          </p>
        </div>
        {items?.map((item) => (
          <div
            key={item.productId._id}
            className="items-center border p-2 mb-4 rounded-lg shadow-md"
          >
            <div className="flex">
              <img
                src={`${process.env.REACT_APP_URL}/${item.productId.images[0]}`}
                alt={item.productId.name}
                className="md:w-20 md:h-24 w-16 h-20 object-cover rounded-md"
              />
              <div className="ml-4 flex flex-col flex-grow">
                <div className="flex justify-between items-start">
                  <h4 className="md:text-lg font-medium">
                    {item.productId.name}
                  </h4>
                  <p className="text-gray-600 mb-2 hidden md:block">
                    {item.productId.price}
                  </p>
                </div>
                <div className="flex text-sm md:text-md">
                  <p className="text-gray-500 flex">
                    Color: {item.productId.color} |
                  </p>
                  <p className="text-gray-500 mb-2">Size: {item.size} |</p>
                </div>
                <div className="flex items-center md:space-x-2 md:text-md text-xs md:mt-1">
                  <p className="mr-1">QTY: {item.quantity}</p>
                </div>
                <p className="text-gray-600 mb-2 text-lg md:hidden">
                  {item.productId.price}
                </p>
              </div>
            </div>
          </div>
        ))}
        <div className="p-2 space-y-0">
          <div className="flex justify-between">
            <span className="w-20">Item Total:</span>
            <span className="">₹{totalCartAmount}</span>
          </div>
          <div className="flex justify-between mb-2">
            <span>Delivery Charges:</span>
            <div>₹{totalCartAmount < 2000 ? deliveryCharges : 0}</div>
          </div>
          <div className="flex justify-between">
            <p>Coupon Discount:</p>
            <p>- ₹{totalAfterDelivery - totalAfterDiscount}</p>
          </div>
          <div className="flex justify-between font-semibold pt-2">
            <p>Total Amount:</p>
            <p>₹{totalAfterDiscount}</p>
          </div>
        </div>
      </div>
    </Modal>
  );
};

export default OrderSummary;
